<nav class="nav">
    <div class="nav-container">
        <h4>Admin - {{ companyName }}</h4>

        <p-divider />

        <p-panelmenu [model]="menuItems">
        </p-panelmenu>
    </div>
    <ng-content></ng-content>
</nav>